/**
 * Work Ability Card Page
 * Full page for managing the Work Ability Card
 */
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ChevronLeft } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { WorkAbilityCard } from '@/components/WorkAbilityCard';
import { useAuth, useLanguage } from '@/lib/context';

export function WorkAbilityCardPage() {
  const navigate = useNavigate();
  const { user } = useAuth();
  const { t } = useLanguage();

  if (!user) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center">
          <h1 className="text-xl font-semibold mb-2">{t('auth.loginRequired')}</h1>
          <p className="text-gray-600 mb-4">{t('capabilityCard.loginToManage')}</p>
          <Button onClick={() => navigate('/login')}>{t('auth.login')}</Button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100">
      {/* Header */}
      <div className="bg-white border-b sticky top-0 z-10">
        <div className="max-w-4xl mx-auto px-4 py-3 flex items-center">
          <Button variant="ghost" size="sm" onClick={() => navigate(-1)}>
            <ChevronLeft className="h-4 w-4 mr-1" />
            {t('common.back')}
          </Button>
        </div>
      </div>

      {/* Content */}
      <div className="py-8 px-4">
        <WorkAbilityCard />
      </div>
    </div>
  );
}

export default WorkAbilityCardPage;
